module.exports = __webpack_public_path__ + "img/github.92878df1.svg";